import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { PageService } from '../services/page.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ExpedientesService } from '../services/expedientes.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { CocheModalComponent } from '../modal/coche-modal/coche-modal.component';
import { AyudaModalComponent } from '../modal/ayuda-modal/ayuda-modal.component';
import { ExcelExport } from '../services/excelExport';
import { UploadFilesComponent } from '../../components/modal/upload-files/upload-files.component';
import * as FileSaver from 'file-saver';
import { EmailModalComponent } from '../modal/email-modal/email-modal.component';
import Swal from 'sweetalert2';
import { MultipleSearchExpedienteModalComponent } from '../../components/modal/multiple-search-expediente-modal/multiple-search-expediente-modal.component';
import { MultipleSearchBastidorModalComponent } from '../../components/modal/multiple-search-bastidor-modal/multiple-search-bastidor-modal.component';
import { MultipleSearchMatriculaModalComponent } from '../../components/modal/multiple-search-matricula-modal/multiple-search-matricula-modal.component';
import { ModalInjectorService } from '../services/modal-injector.service';
import { SelectionModel } from '@angular/cdk/collections';
import { CheckSigafirmaComponent } from '../modal/check-sigafirma/check-sigafirma.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FirmaExpedienteModalComponent } from '../modal/firma-expediente-modal/firma-expediente-modal.component';

@Component({
  selector: 'app-expedientes',
  templateUrl: './expedientes.component.html',
  styleUrls: ['./expedientes.component.css'],
  animations: [
    trigger('detailExpand', [
      state(
        'void',
        style({ height: '0px', minHeight: '0', visibility: 'hidden' })
      ),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ExpedientesComponent implements OnInit, AfterViewInit {
  fromDate: string;
  toDate: string;

  colaboradores: any[];
  docList: any[] = [];
  facturasList: any[] = [];
  excelLoading = false;

  dowloadFiles = [];
  dowloadFacturas = [];
  expComprador: any;
  expVendedor: any;

  pageEvent: PageEvent;
  pageIndex: number;
  pageSize: number;

  // FILTRO
  filtro: any = {
    fInicio: null,
    fFin: null,
    fRec: null,
    fSal: null,
    tipo: null,
    estado: null,
    bastidor: null,
    matricula: null,
    nifCliente: null,
    expediente: null,
  };

  // DataSources para Mat-tables
  lenghtPagination: number;
  datos: any;
  expedientes = null;
  selection = new SelectionModel(true, []);
  bastidor = '';
  vehiculo: any;
  cliente: any;
  clienteVendedor: any;
  sigla: any;
  siglaVendedor: any;
  status = '';
  nifVendedor: any;
  lineasExpedientes = null;
  lineasIncidencias = null;
  ayudas = null;
  esTesla= false;
  // Controlador de cierre/apertura
  cambiado = true;
  fondoTab = '#5A1727';
  id = null;
  nifcliente;
  rango = {
    inicio: '',
    fin: '',
  };
  cars: any[] = [];
  clts: any[] = [];
  dir: any[] = [];
  // Def de columnas para Mat-tables
  displayedColumns: string[] = [
    'select',
    'ampliar',
    'numPedido',
    'numExpediente',
    'vehiculo',
    'nifCliente',
    'bastidor',
    'tramite',
    'status',
    'statusAyuda',
    'colaborador',
    'fechaEntrada',
    'fechaSalida',
    'actions',
  ];
  lineasExpCols: string[] = ['linea', 'descripcion', 'fechaIni', 'fechaFin'];
  lineasInCol: string[] = [
    'usuario',
    'accion',
    'frecepcion',
    'estado',
    'incidencia',
    'fresolucion',
    'descripcion',
  ];

  lineasAyudas: string[] = [
    'tipoAyuda',
    //'tipoSolicitante',
    //'tipoAdquisicion',
    //'ayudaAdicional',
    //'importeAyudaMinimis',
    //'achatarraVehiculo',
    //'matriculaAchatarrado',
    //'marcaAchatarrado',
    //'modeloAchatarrado',
    //'fechaMatriculacionAchatarrado',
    //'marcaModeloElectrico',
    //'esDemo',
    //'autonomiaElectrica',
    //'potenciaKwh',
    //'facturarA',
    'importeAyuda',
    'estadoAyuda',
    'expedienteAyuda',
  ];
  // columnas = ['fContacto', 'fecha', 'email', 'contacto', 'telefono', 'ciclo' , 'estado'];

  // Paginator y sorter para Mat-Tables
  @ViewChild('MatPaginator', { static: false, read: true })
  paginator: MatPaginator;

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  // Busqueda
  public searchForm: FormGroup;

  public expdiente = '';
  public matricula = '';
  public nifCliente = '';
  public bastidorIn = '';
  public tramite = '';
  public colaborador = '';
  public entrada = '';
  public salida = '';
  public numPedido = '';

  // Spinner
  spinner = true;

  tramiteHome = '';
  incidencias: any;
  numExp = '';
  expedienteNumber;

  rol = '';
  spinnerFirma = false;

  sExpansionDetailRow = (index, row) => row.hasOwnProperty('detailRow');

  constructor(
    private pagesService: PageService,
    private expService: ExpedientesService,
    private router: Router,
    private date: DatePipe,
    private dialog: MatDialog,
    private excel: ExcelExport,
    private modalInjector: ModalInjectorService,
    private snackbar: MatSnackBar
  ) {
    if (this.router.getCurrentNavigation() !== null) {
      if (this.router.getCurrentNavigation().extras.state !== undefined) {
        console.log(this.router.getCurrentNavigation());
        this.tramiteHome =
          this.router.getCurrentNavigation().extras.state.tramite;
        this.incidencias =
          this.router.getCurrentNavigation().extras.state.incidencias;
        this.numExp = this.router.getCurrentNavigation().extras.state.numExp;
        this.filtro = {
          fInicio: new Date(new Date().getFullYear(), 0, 1),
          fFin: new Date(),
          fRec: null,
          fSal: null,
          tipo: this.tramiteHome ?? null,
          estado: this.incidencias ?? null,
          bastidor: null,
          matricula: null,
          nifCliente: null,
          expediente: this.numExp ?? null,
          numPedido: this.numPedido ?? null,
        };
        console.log(this.filtro);
      }
    }
  }

  async ngOnInit(): Promise<void> {
    this.getRangoFechas();
    this.expedientes = new MatTableDataSource();
    this.spinner = true;
    const data = await this.getData(true);
    this.expedientes.data = data.items;

    this.datos = data.items;
    this.lenghtPagination = data.count;
    this.pageIndex = data.page - 1;
    this.pageSize = data.size;
    this.spinner = false;

    if(this.colaboradores[0].substr(0,5).toUpperCase()=="TESLA")
    {
      this.esTesla=true;
    }
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.expedientes.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows(): void {
    console.log('Documentos rows', this.dowloadFiles);
    console.log('Facturas rows', this.dowloadFacturas);
    let size = this.dowloadFiles.length;
    let size2 = this.dowloadFacturas.length;
    this.dowloadFiles.splice(0, size);
    this.dowloadFacturas.splice(0, size2);
    size = this.dowloadFiles.length;
    size2 = this.dowloadFacturas.length;

    if (this.isAllSelected()) {
      console.log('All selected: Clearing');
      this.selection.clear();
      return;
    }
    console.log(this.expedientes.data.length);
    console.log(this.expedientes.filteredData.length);
    /*
    if (this.expedientes.data.length === this.expedientes.filteredData.length) {
      
      Swal.fire('', 'No se permite seleccionar todos los expedientes, debe filtrar antes.', 'warning');
      this.selection.clear();

      return;
    }
    */
    const elements = [];
    for (const e of this.expedientes.filteredData) {
      console.log('Pushing: ' + e.numeroExpediente);
      elements.push(e.numeroExpediente);
    }
    this.selection.select(...elements);
    this.dowloadFiles = elements;
    this.dowloadFacturas = elements;
    console.log('Documentos', this.dowloadFiles);
    console.log('Facturas', this.dowloadFacturas);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.position + 1
    }`;
  }

  async getData(pag): Promise<any> {
    this.rol = sessionStorage.getItem('rol') ?? '';
    switch (this.rol) {
      case 'GRUPO':
        this.colaboradores = JSON.parse(
          sessionStorage.getItem('colaboradores')
        );
        break;

      default:
        if (sessionStorage.getItem('colaborador') === 'AUTOMOVILES PALMA SA') {
          this.colaboradores = ['AUTOMOVILES PALMA SA', 'MERCADONA SA'];
        } else {
          this.colaboradores = [sessionStorage.getItem('colaborador')];
        }
        break;
    }
    return new Promise((resolve) => {
      this.expService
        .getExpedientesFiltros(this.colaboradores, this.filtro, pag)
        .subscribe((res: any) => {
          resolve(res);
        });
    });
  }

  ngAfterViewInit(): void {
    this.expedientes.paginator = this.paginator;
    this.expedientes.sort = this.sort;
  }

  getRangoFechas(): void {
    this.pagesService.getFechaRangos().subscribe((res) => {
      console.log(res);
      this.rango = res;
      this.fromDate = res.inicio;
      this.toDate = res.fin;
      this.searchFormInit(res);
    });
  }

  searchFormInit(res): void {
    this.searchForm = new FormGroup({
      expediente: new FormControl(''),
      numPedido: new FormControl(''),
      matricula: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      nifCliente: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      bastidor: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      tramite: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      colaborador: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      estado: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      entrada: new FormControl(),
      salida: new FormControl(),
      fromDate: new FormControl(res.inicio),
      toDate: new FormControl(res.fin),
    });
  }

  addLineasExpediente(element, index): void {
    this.clienteVendedor = null;
    this.bastidor = element.bastidor;
    this.nifcliente = element.nifCliente;
    this.nifVendedor = element.nifVendedor;
    this.expedienteNumber = element.numeroExpediente;

    if (this.id !== null && this.id !== index) {
      document.getElementById(index).hidden = false;
      document.getElementById(this.id).hidden = true;
      this.cambiado = true;
    }

    if (this.id === null || this.id === index) {
      this.cambiado = this.id === null;
      this.id = index;
      const hidden = document.getElementById(this.id).hidden;
      document.getElementById(this.id).hidden = !hidden;
    }
    this.cargarVehiculoYDocumentos();
    this.id = index;
    this.lineasExpedientes = new MatTableDataSource(element.lineasExpedientes);
    this.lineasIncidencias = new MatTableDataSource(element.lineasIncidencias);
    this.ayudas = new MatTableDataSource(element.ayudas);
  }

  cargarVehiculoYDocumentos(): void {
    if (this.cambiado) {
      this.expService.getDocumentos(this.expedienteNumber).subscribe((res) => {
        console.log(res);
        if (res) {
          this.docList = res;
        }
      });
      this.expService.getVehiculo(this.bastidor).subscribe((res) => {
        if (res) {
          this.vehiculo = res;
          console.log(this.vehiculo);
        }
      });
      this.expService.getFacturas(this.expedienteNumber).subscribe((res) => {
        console.log(res);
        if (res) {
          this.facturasList = res;
        }
      });
      this.pagesService.getCliente(this.nifcliente).subscribe((res) => {
        if (res) {
          this.cliente = res;
          console.log("CLIENTE:");
          console.log(this.cliente);
          this.expService
            .getSigla(this.cliente.siglasCalle)
            .subscribe((data) => {
              console.log(data);
              this.sigla = data;
            });
        }
      });
      this.pagesService.getCliente(this.nifVendedor).subscribe((res) => {
        if (res) {
          this.clienteVendedor = res;
          console.log("CLIENTE VENDEDOR:");
          console.log(this.clienteVendedor);
          this.expService
            .getSigla(this.clienteVendedor.siglasCalle)
            .subscribe((data) => {
              console.log(data);
              this.siglaVendedor = data;
            });
        }
        else
        {
          console.log("NO HAY CLIENTE VENDEDOR");
        }
      });
    }
  }

  applyFilter(): void {
    this.expedientes.data = [];
    this.id = null;
    console.log(this.searchForm.value);
    // tslint:disable-next-line:max-line-length
    const nPed =
      this.searchForm.get('numPedido').value === null
        ? null
        : this.searchForm.get('numPedido').value.length <= 3
        ? null
        : this.searchForm.get('numPedido').value;
    // tslint:disable-next-line:max-line-length
    const exp =
      this.searchForm.get('expediente').value === null
        ? null
        : this.searchForm.get('expediente').value.length <= 3
        ? null
        : this.searchForm.get('expediente').value;
    // tslint:disable-next-line:max-line-length
    const mat =
      this.searchForm.get('matricula').value === null
        ? null
        : this.searchForm.get('matricula').value.length <= 2
        ? null
        : this.searchForm.get('matricula').value;
    // tslint:disable-next-line:max-line-length
    const nif =
      this.searchForm.get('nifCliente').value === null
        ? null
        : this.searchForm.get('nifCliente').value.length <= 2
        ? null
        : this.searchForm.get('nifCliente').value;
    // tslint:disable-next-line:max-line-length
    const bas =
      this.searchForm.get('bastidor').value === null
        ? null
        : this.searchForm.get('bastidor').value.length <= 4
        ? null
        : this.searchForm.get('bastidor').value;
    const tra =
      this.searchForm.get('tramite').value === null
        ? null
        : this.searchForm.get('tramite').value.toUpperCase();
    const sta = this.searchForm.get('estado').value;
    const ent = this.date.transform(
      this.searchForm.get('entrada').value,
      'dd-MM-yyyy'
    );
    const sal = this.date.transform(
      this.searchForm.get('salida').value,
      'dd-MM-yyyy'
    );
    //const fromDate = this.searchForm.get('fromDate').value;
    //const toDate = this.searchForm.get('toDate').value;
    this.fromDate = this.searchForm.get('fromDate').value;
    this.toDate = this.searchForm.get('toDate').value;

    this.filtro = {
      fInicio: this.fromDate,
      fFin: this.toDate,
      fRec: ent,
      fSal: sal,
      expediente: exp,
      matricula: mat,
      tipo: tra,
      estado: sta,
      bastidor: bas,
      nifCliente: nif,
      numPedido: nPed,
    };

    console.log('Filtro', this.filtro);
    console.log('FromDate', this.filtro.fInicio);
    console.log('ToDate', this.filtro.fFin);

    const col = this.searchForm.get('colaborador').value;
    //console.log('colllllllll', col);
    if (col !== null && col !== '') {
      this.expService
        .getExpedientesFiltros(
          [this.searchForm.get('colaborador').value],
          this.filtro,
          true
        )
        .subscribe((res) => {
          this.expedientes.data = res.items;
          console.log(res);
          this.lenghtPagination = res.count;
          this.pageIndex = res.page - 1;
          this.pageSize = res.size;
          return event;
        });
    } else {
      console.log(this.colaboradores);
      console.log(this.filtro);

      this.expService
        .getExpedientesFiltros(this.colaboradores, this.filtro, true)
        .subscribe((res) => {
          this.expedientes.data = res.items;
          console.log('Response', res);
          this.lenghtPagination = res.count;
          this.pageIndex = res.page - 1;
          this.pageSize = res.size;
          return event;
        });
    }
  }

  resetFechas(): void {
    //this.getRangoFechas();
    this.searchForm.get('fromDate').reset();
    this.searchForm.get('toDate').reset();
    //this.applyFilter();
    //this.getServerData();
  }

  abrirModal(): void {
    console.log("Abriendo modal vehículo:");
    console.log(this.vehiculo);
    const dialogRef = this.dialog.open(CocheModalComponent, {
      width: '90%',

      data: this.vehiculo,
      panelClass: 'custom-dialog-container',
    });
  }

  abrirModalAyuda(): void {
    //console.log("Abriendo modal ayuda:");
    //console.log(this.ayudas.data[0]);
    const dialogRef = this.dialog.open(AyudaModalComponent, {
      width: '90%',

      data: this.ayudas.data[0],
      panelClass: 'custom-dialog-container',
    });
  }

  verArchivo(doc, nombreCliente, vehiculo): void {
    this.expService.getDocumentoss(doc.id).subscribe((response) => {
      console.log(response);
      const file = new Blob([response]);
      const filename = doc.file.name;
      const extension = filename.substr(-3);
      console.log(extension);
      const a = FileSaver.saveAs(
        file,
        doc.typeSettings.docType.name +
          '_' +
          nombreCliente.replace(' ', '') +
          '_' +
          vehiculo +
          '.' +
          extension
      );
      // const fileUrl = URL.createObjectURL( FileSaver.saveAs(file, doc.file.name));
      // window.open(a);
    });
  }

  verFactura(doc, nombreCliente, vehiculo): void {
    this.expService.getFacturass(doc.id).subscribe((response) => {
      console.log(response);
      const file = new Blob([response]);
      const filename = doc.file.name;
      const extension = filename.substr(-3);
      console.log(extension);
      const a = FileSaver.saveAs(
        file,
        doc.typeSettings.docType.name +
          '_' +
          nombreCliente.replace(' ', '') +
          '_' +
          vehiculo +
          '.' +
          extension
      );
      // const fileUrl = URL.createObjectURL( FileSaver.saveAs(file, doc.file.name));
      // window.open(a);
    });
  }

  async excelGenerate(): Promise<void> {
    this.spinner = true;
    this.excelLoading = true;

    const datos = await this.getData(false);
    const data = [];

    for (let e = 0; e < datos.length; e++) {
      data.push({
        Matricula: datos[e].vehiculo == null ? '' : datos[e].vehiculo.matricula,
        NIF: datos[e].exp == null ? '' : datos[e].exp.nifCliente,
        Nombre: datos[e].cliente == null ? '' : datos[e].cliente.nombreCliente,
        'Primer Apellido':
          datos[e].cliente == null ? '' : datos[e].cliente.apellido1Cliente,
        'Segundo Apellido':
          datos[e].cliente == null ? '' : datos[e].cliente.apellido2Cliente,
        Municipio: datos[e].dir == null ? '' : datos[e].dir.poblacion,
        'C.P.': datos[e].dir == null ? '' : datos[e].dir.cp,
        // tslint:disable-next-line:max-line-length
        'F. Nacimiento':
          datos[e].cliente == null
            ? ''
            : this.date.transform(
                datos[e].cliente.fechanacimientoCliente,
                'dd/MM/yyyy'
              ),
        Bastidor: datos[e].exp == null ? '' : datos[e].exp.bastidor,
        Modelo: datos[e].vehiculo == null ? '' : datos[e].vehiculo.modelo,
        Color: datos[e].vehiculo == null ? '' : datos[e].vehiculo.color,
        Tramite: datos[e].exp == null ? '' : datos[e].exp.tramite,
        'Fecha Entrada':
          datos[e].exp == null
            ? ''
            : this.date.transform(datos[e].exp.fechaEntrada, 'dd/MM/yyyy'),
        Expediente: datos[e].exp == null ? '' : datos[e].exp.numeroExpediente,
        Colaborador: datos[e].exp == null ? '' : datos[e].exp.colaborador,
        Proceso: datos[e].exp == null ? '' : datos[e].exp.status,
        'Importe Total':
          datos[e].exp == null ? '' : datos[e].exp.importeTotalFactura,
      });
    }
    console.log(data);
    this.excel.exportExcel(data, 'Expedientes' + Date.now());

    this.spinner = false;
    this.excelLoading = false;
  }

  getAutos(bastidor): Promise<any> {
    return new Promise((resolve) => {
      this.expService.getVehiculo(bastidor).subscribe((res: any) => {
        resolve(res);
      });
    });
  }

  getClnts(nifCliente): Promise<any> {
    return new Promise((resolve) => {
      this.pagesService.getCliente(nifCliente).subscribe((resp: any) => {
        resolve(resp);
      });
    });
  }

  getDirections(idDireccion): Promise<any> {
    return new Promise((resolve) => {
      this.pagesService.getDireccion(idDireccion).subscribe((r: any) => {
        resolve(r[0]);
      });
    });
  }

  openDialog(elemento): void {
    console.log(elemento);
    const dialogRef = this.dialog.open(UploadFilesComponent, {
      width: '900px',
      maxWidth: '95vw',
      data: {
        id: elemento.numeroExpediente,
        solictud: false,
      },
    });
  }

  enviar(elemento, cliente): void {
    const ref = this.dialog.open(EmailModalComponent);
    ref.afterClosed().subscribe((result) => {
      if (result === true) {
        this.expService
          .sendFilesEmailCliente(
            elemento.numeroExpediente,
            cliente.nombreCliente,
            false,
            cliente.emailCliente
          )
          .subscribe(
            (res) => {
              console.log(res);
              Swal.fire('', 'Email enviado con éxito', 'success');
            },
            () => {
              Swal.fire(
                '',
                'Ha ocurrido un problema, intentelo más tarde',
                'warning'
              );
            }
          );
      }
    });
  }

  multipleSearch(): void {
    const ref = this.dialog.open(MultipleSearchExpedienteModalComponent, {
      width: '40%',
    });
    ref.afterClosed().subscribe((result) => {
      if (result.length > 0) {
        console.log('ARRAY DE PEDIDOS', result);
        // TODO: LLAMAR A API Y PASARLE EL ARRAY DE RESULT
        this.expService
          .multipleSearch(result, this.colaboradores)
          .subscribe((results) => {
            console.log('RSULTADO MULTIPLE SEARCH', results);
            this.expedientes.data = results;
          });
      }
    });
  }

  multipleSearchBastidor(): void {
    const ref = this.dialog.open(MultipleSearchBastidorModalComponent, {
      width: '50%',
    });
    ref.afterClosed().subscribe((result) => {
      if (result.length > 0) {
        console.log('ARRAY DE PEDIDOS', result);
        // TODO: LLAMAR A API Y PASARLE EL ARRAY DE RESULT
        this.expService
          .multipleSearchBastidores(result, this.colaboradores)
          .subscribe((results: any) => {
            console.log('RSULTADO MULTIPLE SEARCH', results);
            this.expedientes.data = results;
          });
      }
    });
  }

  multipleSearchMatricula(): void {
    const ref = this.dialog.open(MultipleSearchMatriculaModalComponent, {
      width: '40%',
    });
    ref.afterClosed().subscribe((result) => {
      if (result.length > 0) {
        console.log('ARRAY DE PEDIDOS', result);
        this.expService
          .multipleSearchMatriculas(result, this.colaboradores)
          .subscribe((results) => {
            console.log('RESULTADO MULTIPLE SEARCH', results);
            this.expedientes.data = results;
          });
      }
    });
  }

  setExpedientesToDownloads(add, numeroExpediente): void {
    if (add === true) {
      this.dowloadFiles.push(numeroExpediente);
      this.dowloadFacturas.push(numeroExpediente);
    } else {
      for (let i = 0; i < this.dowloadFiles.length; i++) {
        if (this.dowloadFiles[i] === numeroExpediente) {
          this.dowloadFiles.splice(i, 1);
        }
      }
      for (let i = 0; i < this.dowloadFacturas.length; i++) {
        if (this.dowloadFacturas[i] === numeroExpediente) {
          this.dowloadFacturas.splice(i, 1);
        }
      }
    }
    console.log('ARRAY DOWNLOAD FILES', this.dowloadFiles);
    console.log('ARRAY DOWNLOAD FACTURAS', this.dowloadFacturas);
  }

  dowloadZip(tipo: string): void {
    console.log('Tipo de archivo', tipo);
    /*let link = document.createElement("a");
    link.download = "bulk-files";
    link.href = "assets/bulk/Bulk.zip";
    link.click();*/

    if (tipo === 'DOCUMENTOS') {
      this.spinner = true;
      this.expService.getBulkFilesExpediente(this.dowloadFiles).subscribe(
        (res) => {
          this.spinner = false;

          const link = document.createElement('a');
          link.download = 'bulk-files';
          link.href = res;
          link.click();
        },
        () => {
          this.spinner = false;
          Swal.fire(
            '',
            'Ha ocurrido un problema, intentelo más tarde',
            'warning'
          );
        }
      );
    } else if (tipo === 'FACTURAS') {
      this.spinner = true;
      this.expService.getBulkFacturasExpediente(this.dowloadFacturas).subscribe(
        (res) => {
          this.spinner = false;

          const link = document.createElement('a');
          link.download = 'bulk-files';
          link.href = res;
          link.click();
        },
        () => {
          this.spinner = false;
          Swal.fire(
            '',
            'Ha ocurrido un problema, intentelo más tarde',
            'warning'
          );
        }
      );
    }
  }

  checkDataVendedor(expediente): boolean {
    this.expVendedor = {
      nombre:
        expediente.nombreCliente === ''
          ? null
          : expediente.nombreCliente === undefined
          ? null
          : expediente.nombreCliente,
      // tslint:disable-next-line:max-line-length
      nombreApoderado:
        expediente.nombreApoderado === ''
          ? null
          : expediente.nombreApoderado === undefined
          ? null
          : expediente.nombreApoderado,
      apellido1:
        expediente.apellido1Cliente === ''
          ? null
          : expediente.apellido1Cliente === undefined
          ? null
          : expediente.apellido1Cliente,
      // tslint:disable-next-line:max-line-length
      apellido1Apoderado:
        expediente.apellido1Apoderado === ''
          ? null
          : expediente.apellido1Apoderado === undefined
          ? null
          : expediente.apellido1Apoderado,
      apellido2:
        expediente.apellido2Cliente === ''
          ? null
          : expediente.apellido2Cliente === undefined
          ? null
          : expediente.apellido2Cliente,
      // tslint:disable-next-line:max-line-length
      apellido2Apoderado:
        expediente.apellido2Apoderado === ''
          ? null
          : expediente.apellido2Apoderado === undefined
          ? null
          : expediente.apellido2Apoderado,
      nif:
        expediente.nifCliente === ''
          ? null
          : expediente.nifCliente === undefined
          ? null
          : expediente.nifCliente,
      nifApoderado:
        expediente.nifApoderado === ''
          ? null
          : expediente.nifApoderado === undefined
          ? null
          : expediente.nifApoderado,
      sexo:
        expediente.sexoCliente === ''
          ? null
          : expediente.sexoCliente === undefined
          ? null
          : expediente.sexoCliente,
      telefono:
        expediente.telefonoCliente === ''
          ? null
          : expediente.telefonoCliente === undefined
          ? null
          : expediente.telefonoCliente,
      email:
        expediente.emailCliente === ''
          ? null
          : expediente.emailCliente === undefined
          ? null
          : expediente.emailCliente,
      provincia:
        expediente.provinciaCliente === ''
          ? null
          : expediente.provinciaCliente === undefined
          ? null
          : expediente.provinciaCliente,
      poblacion:
        expediente.poblacionCliente === ''
          ? null
          : expediente.poblacionCliente === undefined
          ? null
          : expediente.poblacionCliente,
      // tslint:disable-next-line:max-line-length
      cp:
        expediente.codigopostalCliente === ''
          ? null
          : expediente.codigopostalCliente === undefined
          ? null
          : expediente.codigopostalCliente,
      direccion:
        expediente.direccionCliente === ''
          ? null
          : expediente.direccionCliente === undefined
          ? null
          : expediente.direccionCliente,
      // tslint:disable-next-line:max-line-length
      direccionnumero:
        expediente.direccionnumeroCliente === ''
          ? null
          : expediente.direccionnumeroCliente === undefined
          ? null
          : expediente.direccionnumeroCliente,
      // tslint:disable-next-line:max-line-length
      matricula:
        this.vehiculo.matricula === null
          ? null
          : this.vehiculo.matricula === ''
          ? null
          : this.vehiculo.matricula === undefined
          ? null
          : this.vehiculo.matricula,
      // tslint:disable-next-line:max-line-length
      bastidor:
        this.vehiculo.bastidor === null
          ? null
          : this.vehiculo.bastidor === ''
          ? null
          : this.vehiculo.bastidor === undefined
          ? null
          : this.vehiculo.bastidor,
    };
    return true;
  }
  checkDataComprador(expediente): boolean {
    this.expComprador = {
      nombre:
        expediente.nombreCliente === ''
          ? null
          : expediente.nombreCliente === undefined
          ? null
          : expediente.nombreCliente,
      // tslint:disable-next-line:max-line-length
      nombreApoderado:
        expediente.nombreApoderado === ''
          ? null
          : expediente.nombreApoderado === undefined
          ? null
          : expediente.nombreApoderado,
      apellido1:
        expediente.apellido1Cliente === ''
          ? null
          : expediente.apellido1Cliente === undefined
          ? null
          : expediente.apellido1Cliente,
      // tslint:disable-next-line:max-line-length
      apellido1Apoderado:
        expediente.apellido1Apoderado === ''
          ? null
          : expediente.apellido1Apoderado === undefined
          ? null
          : expediente.apellido1Apoderado,
      apellido2:
        expediente.apellido2Cliente === ''
          ? null
          : expediente.apellido2Cliente === undefined
          ? null
          : expediente.apellido2Cliente,
      // tslint:disable-next-line:max-line-length
      apellido2Apoderado:
        expediente.apellido2Apoderado === ''
          ? null
          : expediente.apellido2Apoderado === undefined
          ? null
          : expediente.apellido2Apoderado,
      nif:
        expediente.nifCliente === ''
          ? null
          : expediente.nifCliente === undefined
          ? null
          : expediente.nifCliente,
      nifApoderado:
        expediente.nifApoderado === ''
          ? null
          : expediente.nifApoderado === undefined
          ? null
          : expediente.nifApoderado,
      sexo:
        expediente.sexoCliente === ''
          ? null
          : expediente.sexoCliente === undefined
          ? null
          : expediente.sexoCliente,
      telefono:
        expediente.telefonoCliente === ''
          ? null
          : expediente.telefonoCliente === undefined
          ? null
          : expediente.telefonoCliente,
      email:
        expediente.emailCliente === ''
          ? null
          : expediente.emailCliente === undefined
          ? null
          : expediente.emailCliente,
      provincia:
        expediente.provinciaCliente === ''
          ? null
          : expediente.provinciaCliente === undefined
          ? null
          : expediente.provinciaCliente,
      poblacion:
        expediente.poblacionCliente === ''
          ? null
          : expediente.poblacionCliente === undefined
          ? null
          : expediente.poblacionCliente,
      // tslint:disable-next-line:max-line-length
      cp:
        expediente.codigopostalCliente === ''
          ? null
          : expediente.codigopostalCliente === undefined
          ? null
          : expediente.codigopostalCliente,
      direccion:
        expediente.direccionCliente === ''
          ? null
          : expediente.direccionCliente === undefined
          ? null
          : expediente.direccionCliente,
      // tslint:disable-next-line:max-line-length
      direccionnumero:
        expediente.direccionnumeroCliente === ''
          ? null
          : expediente.direccionnumeroCliente === undefined
          ? null
          : expediente.direccionnumeroCliente,
      // tslint:disable-next-line:max-line-length
      matricula:
        this.vehiculo.matricula === null
          ? null
          : this.vehiculo.matricula === ''
          ? null
          : this.vehiculo.matricula === undefined
          ? null
          : this.vehiculo.matricula,
      // tslint:disable-next-line:max-line-length
      bastidor:
        this.vehiculo.bastidor === null
          ? null
          : this.vehiculo.bastidor === ''
          ? null
          : this.vehiculo.bastidor === undefined
          ? null
          : this.vehiculo.bastidor,
    };
    return true;
  }

  enviarSMS(datosCliente, exp): void {
    console.log(datosCliente);
    console.log(exp);
    let name;
    let dni;
    let empresa;
    let cifempresa;
    let po;
    if (datosCliente.sexo === 'X') {
      name =
        datosCliente.nombreApoderado +
        ' ' +
        datosCliente.apellido1Apoderado +
        ' ' +
        datosCliente.apellido2Apoderado;
      dni = datosCliente.nifApoderado;
      empresa = datosCliente.apellido1;
      cifempresa = datosCliente.nif;
      po = true;
    } else {
      name =
        datosCliente.nombre +
        ' ' +
        datosCliente.apellido1 +
        ' ' +
        datosCliente.apellido2;
      dni = datosCliente.nif;
      empresa = '';
      cifempresa = '';
      po = false;
    }
    const json = {
      data: {
        nombre: name, // Nombre completo, si es empresa nombre completo del apoderado
        email: datosCliente.email,
        tel: datosCliente.telefono,
        nif: dni, // Si es empresa, nif del apoderado
        calle: datosCliente.direccion,
        numero: datosCliente.direccionnumero,
        cp: datosCliente.cp,
        poblacion: datosCliente.poblacion,
        empresaNombre: empresa, // Si no es empresa string vacio
        cif: cifempresa, // Si no es empresa string vacio
        // si no hay matricula string vacio
        matricula:
          this.vehiculo.matricula === null
            ? ''
            : this.vehiculo.matricula === undefined
            ? ''
            : this.vehiculo.matricula,
        // Si no hau bastidor string vacio
        bastidor:
          this.vehiculo.bastidor === null
            ? ''
            : this.vehiculo.bastidor === undefined
            ? ''
            : this.vehiculo.bastidor,
        tramite: exp.tramite, // Propiedad tramite del expediente
        numExp: exp.numeroExpediente, // numero de expdiente
      },
      doc: {
        mandato: true,
        poder: po, // sexo === 'X' ? true : false
      },
    };
    this.spinnerFirma = true;
    this.modalInjector.enviarSMSViaFirma(json).subscribe(
      (res) => {
        this.spinnerFirma = false;
        if (res.result === 'ok') {
          this.snackbar.open('Mensaje sms enviado correctamente', '', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'snack-cliente-ok',
            duration: 5000,
          });
        }
        if (res.result === 'error') {
          this.snackbar.open(res.message, 'OK', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'snack-cliente',
            duration: 8000,
          });
        }
      },
      (error) => {
        console.log(error);
        this.spinnerFirma = false;
        this.snackbar.open(
          'No se ha podiodo enviar el mensaje sms, revise los datos.',
          'OK',
          {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'snack-cliente',
            duration: 5000,
          }
        );
      }
    );
  }

  getServerData(event?: PageEvent): any {
    //Reseteando lista de documentos a descargar
    const size = this.dowloadFiles.length;
    const size2 = this.dowloadFacturas.length;
    this.dowloadFiles.splice(0, size);
    this.dowloadFacturas.splice(0, size2);

    if (this.isAllSelected()) {
      console.log('All selected: Clearing');
      this.selection.clear();
      console.log(this.selection);
    }

    console.log(event);
    this.spinner = true;
    this.expService
      .getExpedientesFiltros(
        this.colaboradores,
        this.filtro,
        true,
        event?.pageIndex + 1
      )
      .subscribe((res) => {
        this.expedientes.data = res.items;
        console.log(res);
        this.datos = res.items;
        this.lenghtPagination = res.count;
        this.pageIndex = res.page - 1;
        this.pageSize = res.size;
        this.spinner = false;
        return event;
      });
  }

  abrirModalComprobacionSigafirma(elemento): void {
    this.dialog.open(CheckSigafirmaComponent, {
      data: { tipo: 'expediente', id: elemento.numeroExpediente },
    });
  }

  abrirModalEnvioFirma(element): void {
    this.dialog.open(FirmaExpedienteModalComponent, {
      data: element,
      hasBackdrop: true,
    });
  }

  getEstadoAyuda(element): string {
    
    if(element.ayudas.length>0)
      return element.ayudas[0].estadoAyuda;
    else
      return "-";
  }
  
}
